import React, { Fragment } from 'react';
import { string, bool } from 'prop-types';

import Icon from 'components/icon';

const BrandDownloadCard = ({
    blocked,
    url,
    title,
    size,
    blockedTitle,
    downloadTitle
}) => {
    const renderContent = () => (
        <Fragment>
            <h3 className="c-brand-card__title">{title}</h3>
            <div className="c-brand-download-card__body">
                <span className="c-brand-download-card__size">{size}</span>
                {blocked ? (
                    <span className="c-brand-download-card__link">
                        {blockedTitle} <Icon glyph="lock" />
                    </span>
                ) : (
                    <span className="c-brand-download-card__link">
                        {downloadTitle} <Icon glyph="download-line" />
                    </span>
                )}
            </div>
        </Fragment>
    );

    return (
        <Fragment>
            {blocked ? (
                <div className="c-brand-download-card c-brand-card">
                    {renderContent()}
                </div>
            ) : (
                <a
                    className="c-brand-download-card c-brand-card"
                    href={url}
                    download
                >
                    {renderContent()}
                </a>
            )}
        </Fragment>
    );
};

BrandDownloadCard.propTypes = {
    blocked: bool,
    url: string.isRequired,
    title: string.isRequired,
    size: string.isRequired,
    blockedTitle: string,
    downloadTitle: string
};

export default BrandDownloadCard;
